export default __webpack_public_path__ + "static/media/302.e87e8d81.png";